import { Navigate, useRoutes } from 'react-router-dom';
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { profileRoutes } from 'src/routes/sections/profile';
import { extraRoutes } from './extra';
import { authRoutes } from './auth';
import { appRoutes, Dashboard } from './app';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <AuthGuard>
          <DashboardLayout>
            <Dashboard />
          </DashboardLayout>
        </AuthGuard>
      ),
    },
    ...authRoutes,
    ...extraRoutes,
    ...appRoutes,
    ...profileRoutes,
    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
